import src from "IMAGE";
export default { src, width: 2070, height: 1132, blurWidth: 0, blurHeight: 0};
